import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c442b02c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_career_contents_wrapper" }
const _hoisted_2 = { class: "entry_career_indicator" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_career_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_career_title_text" }, "使用可能なプログラミング言語を教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "この項目は任意です", -1))
const _hoisted_5 = { class: "entry_career_input" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "プログラミング言語（複数選択可）")
], -1))
const _hoisted_7 = { class: "entry_career_input_layout_column_1" }
const _hoisted_8 = { class: "entry_career_button" }
const _hoisted_9 = { class: "entry_career_button_prev" }
const _hoisted_10 = { class: "entry_career_button_next" }
const _hoisted_11 = { class: "entry_career_skip" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Indicator from '@/components/Indicator.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import Loading from '@/components/Loading.vue';
import { getUsableLanguage, putUsableLanguage } from '@/api/careersheetEndpoint';
import { putUpdateCareerRegstatus } from '@/api/accountEndpoint';


export default /*#__PURE__*/_defineComponent({
  __name: 'SkillpclanguageView',
  setup(__props) {

const isLoading = ref(false);
const init = async () => {
  isLoading.value = true;
  try {
    const res = await getUsableLanguage();
    langCFlg.value = res.langCFlg || false;
    cplusplusFlg.value = res.cplusplusFlg || false;
    csharpFlg.value = res.csharpFlg || false;
    javaFlg.value = res.javaFlg || false;
    phpFlg.value = res.phpFlg || false;
    sqlFlg.value = res.sqlFlg || false;
    aspFlg.value = res.aspFlg || false;
    javascriptFlg.value = res.javascriptFlg || false;
    htmlFlg.value = res.htmlFlg || false;
    xmlFlg.value = res.xmlFlg || false;
    xhtmlFlg.value = res.xhtmlFlg || false;
    cssFlg.value = res.cssFlg || false;
    sassFlg.value = res.sassFlg || false;
    ftpFlg.value = res.ftpFlg || false;
    wordPressFlg.value = res.wordPressFlg || false;
    movableTypeFlg.value = res.movableTypeFlg || false;
    langRFlg.value = res.langRFlg || false;
    perlFlg.value = res.perlFlg || false;
    rubyFlg.value = res.rubyFlg || false;
    goFlg.value = res.goFlg || false;
    pythonFlg.value = res.pythonFlg || false;
    swiftFlg.value = res.swiftFlg || false;
    kotlinFlg.value = res.kotlinFlg || false;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
init();

const langCFlg = ref(false);
const cplusplusFlg = ref(false);
const csharpFlg = ref(false);
const javaFlg = ref(false);
const phpFlg = ref(false);
const sqlFlg = ref(false);
const aspFlg = ref(false);
const javascriptFlg = ref(false);
const htmlFlg = ref(false);
const xmlFlg = ref(false);
const xhtmlFlg = ref(false);
const cssFlg = ref(false);
const sassFlg = ref(false);
const ftpFlg = ref(false);
const wordPressFlg = ref(false);
const movableTypeFlg = ref(false);
const langRFlg = ref(false);
const perlFlg = ref(false);
const rubyFlg = ref(false);
const goFlg = ref(false);
const pythonFlg = ref(false);
const swiftFlg = ref(false);
const kotlinFlg = ref(false);

const UsableLanguageList = ref([
  { label: 'C', value: langCFlg },
  { label: 'C++', value: cplusplusFlg },
  { label: 'C#', value: csharpFlg },
  { label: 'Java', value: javaFlg },
  { label: 'PHP', value: phpFlg },
  { label: 'SQL', value: sqlFlg },
  { label: 'ASP', value: aspFlg },
  { label: 'Javascript', value: javascriptFlg },
  { label: 'HTML', value: htmlFlg },
  { label: 'XML', value: xmlFlg },
  { label: 'XHTML', value: xhtmlFlg },
  { label: 'CSS', value: cssFlg },
  { label: 'Sass', value: sassFlg },
  { label: 'ftp', value: ftpFlg },
  { label: 'WordPress実装', value: wordPressFlg },
  { label: 'Movable Type実装', value: movableTypeFlg },
  { label: 'R', value: langRFlg },
  { label: 'Perl', value: perlFlg },
  { label: 'Ruby', value: rubyFlg },
  { label: 'Go', value: goFlg },
  { label: 'Python', value: pythonFlg },
  { label: 'Swift', value: swiftFlg },
  { label: 'Kotlin', value: kotlinFlg },
]);

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c09' });
};
const submit = async () => {
  isLoading.value = true;
  try {
    await putUsableLanguage({
      langCFlg: langCFlg.value,
      cplusplusFlg: cplusplusFlg.value,
      csharpFlg: csharpFlg.value,
      javaFlg: javaFlg.value,
      phpFlg: phpFlg.value,
      sqlFlg: sqlFlg.value,
      aspFlg: aspFlg.value,
      javascriptFlg: javascriptFlg.value,
      htmlFlg: htmlFlg.value,
      xmlFlg: xmlFlg.value,
      xhtmlFlg: xhtmlFlg.value,
      cssFlg: cssFlg.value,
      sassFlg: sassFlg.value,
      ftpFlg: ftpFlg.value,
      wordPressFlg: wordPressFlg.value,
      movableTypeFlg: movableTypeFlg.value,
      langRFlg: langRFlg.value,
      perlFlg: perlFlg.value,
      rubyFlg: rubyFlg.value,
      goFlg: goFlg.value,
      pythonFlg: pythonFlg.value,
      swiftFlg: swiftFlg.value,
      kotlinFlg: kotlinFlg.value,
    });
    router.push({ name: 'c11' });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const updateCareerRegstatus = async() => {
  await putUpdateCareerRegstatus();
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 9,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(UsableLanguageList.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.label,
              class: "entry_career_input_layout_column_1_item"
            }, [
              _createVNode(BaseCheckbox, {
                value: false,
                label: item.label,
                modelValue: item.value,
                "onUpdate:modelValue": ($event: any) => ((item.value) = $event)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(BaseButton, {
            onClick: submit,
            theme: "primary",
            type: "button",
            disabled: false
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存して次へ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          class: "entry_career_skip_link",
          to: { name: 'd00' },
          onClick: updateCareerRegstatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("入力せずに面談予約へ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})